import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {FreeDataArgs} from './FreeDataArgs';
import {FreeDataLevel} from './FreeDataLevel';
import {FreeDataValue} from './FreeDataValue';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class FreeData extends BasicEntity {
args: {[key: string]: FreeDataArgs};
chronoCode: string;
code: string;
dataType: string;
defaultTrigger: string;
defaultValue: string;
description: TranslatedEmb;
endDate: number | null;
externalCode: string;
freeDataLevels: {[key: string]: FreeDataLevel};
freeDataValueTree: FreeDataValue[];
freeDataValues: {[key: string]: FreeDataValue};
icon: string;
kindMeasure: boolean | null;
kindWild: boolean | null;
label: TranslatedEmb;
restrict: string;
startDate: number | null;
}

